import { authHeader } from './auth-header'
import { oaxios } from './api-service'

let regulaSdkPromise = null
let regulaProcessing = false

function regulaError(message) {
  const error = new Error(message)
  error.response = { data: { message } }
  return error
}

function loadRegulaSdk() {
  if (window.Regula && window.Regula.DocumentReaderService)
    return Promise.resolve()
  if (regulaSdkPromise) return regulaSdkPromise

  regulaSdkPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = `${process.env.BASE_URL}js/regula-document-reader-9.8.3074.iife.js`
    script.async = true
    script.onload = () => {
      if (window.Regula && window.Regula.DocumentReaderService) resolve()
      else
        reject(
          regulaError('Die Regula-Komponente konnte nicht geladen werden.'),
        )
    }
    script.onerror = () =>
      reject(regulaError('Die Regula-Komponente konnte nicht geladen werden.'))
    document.head.appendChild(script)
  }).catch((error) => {
    regulaSdkPromise = null
    throw error
  })

  return regulaSdkPromise
}

function dataUrlToArrayBuffer(dataUrl) {
  const separator = String(dataUrl || '').indexOf(',')
  if (separator < 0)
    return Promise.reject(
      regulaError('Das Ausweisbild konnte nicht gelesen werden.'),
    )

  try {
    const binary = window.atob(String(dataUrl).slice(separator + 1))
    const bytes = new Uint8Array(binary.length)
    for (let index = 0; index < binary.length; index += 1)
      bytes[index] = binary.charCodeAt(index)
    return Promise.resolve(bytes.buffer)
  } catch (error) {
    return Promise.reject(
      regulaError('Das Ausweisbild konnte nicht gelesen werden.'),
    )
  }
}

function transactionUrl() {
  const backendBase = String(
    process.env.VUE_APP_BACKEND_BASE || '/api',
  ).replace(/\/$/, '')
  return new URL(`${backendBase}/briefgold/regula`, window.location.origin).href
}

function transactionHeaders() {
  const headers = { ...authHeader() }
  delete headers['Content-Type']
  return headers
}

function transactionIdFromResult(result) {
  const transactionId =
    result && result.transactionId
      ? String(result.transactionId).toLowerCase()
      : ''

  if (
    !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(
      transactionId,
    )
  )
    throw regulaError(
      'Regula Forensics hat keine gültige Transaktions-ID geliefert.',
    )

  return transactionId
}

export function regulaV2ReadDocument(frontImage, backImage) {
  if (regulaProcessing)
    return Promise.reject(
      regulaError('Eine Ausweiserfassung wird bereits ausgeführt.'),
    )

  regulaProcessing = true
  let service = null

  return loadRegulaSdk()
    .then(() => {
      service = new window.Regula.DocumentReaderService()
      const processParams = {
        processParam: {
          scenario: 'MrzAndLocate',
          returnUncroppedImage: true,
          returnPackageForReprocess: true,
          backendProcessing: {
            serviceURL: transactionUrl(),
            httpHeaders: transactionHeaders(),
          },
        },
      }

      service.recognizerProcessParam = processParams
      service.imageProcessParam = processParams

      return Promise.all([
        dataUrlToArrayBuffer(frontImage),
        dataUrlToArrayBuffer(backImage),
        service.initialize(),
      ]).then((values) =>
        service
          .createBackendTransaction(
            { module: 'reisebank-partnerportal' },
            processParams,
          )
          .then(() =>
            service.processImage([values[0], values[1]], processParams),
          ),
      )
    })
    .then((result) => {
      const finished =
        result && result.rawResponse
          ? result.rawResponse.ProcessingFinished
          : null
      if (finished !== 1 && finished !== 2)
        throw regulaError(
          `Die Regula-Bildverarbeitung wurde nicht abgeschlossen. ProcessingFinished: ${
            finished === null ? 'unbekannt' : finished
          }.`,
        )

      return service.finalizePackage()
    })
    .then(transactionIdFromResult)
    .then((transactionId) =>
      oaxios('/briefgold/regula', {
        regula_transaction_id: transactionId,
      }),
    )
    .finally(() => {
      if (service) service.shutdown()
      regulaProcessing = false
    })
}
